import React, { useContext, useState } from "react";
import { Accordion, Button, Divider, Grid, Icon, Popup, Table } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import TechnicianTransmissionStore from "../../../app/stores/techniciantransmissionStore";
import { Link } from "react-router-dom";
const TechnicianTransmission: React.FC = () => {
  const techniciantransmissionStore = useContext(TechnicianTransmissionStore);
  const { techniciantransmissionsByDate, ifSubmitted } =
    techniciantransmissionStore;

  const [activeIndex, setActiveIndex] = useState('');

  function convertDate(date: string) {
    var arrDate = date.split("-");
    return arrDate[2] + "/" +arrDate[1] + "/" + arrDate[0];
  };

  function getDayOfWeek(date: string) {
    const dayOfWeek = new Date(date).getDay();    
    return isNaN(dayOfWeek) ? null : 
      ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
  }

  const handleTitleClick = (e: any, titleProps: any) => {
    const { active, index } = titleProps;
    const newIndex = activeIndex === index ? '' : index
    setActiveIndex(newIndex); 
 }

  return (
    <div>
    <Grid style={{backgroundColor: 'lightgrey', marginTop: '0em'}}>
      <Grid.Column width='5'>
           <h4> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Date</h4>
      </Grid.Column>
       <Grid.Column width='3'>
       <h4> Site ID</h4>
      </Grid.Column>
      <Grid.Column width='8'>
       <h4> Site Name</h4>
      </Grid.Column>
    </Grid>
    
    {techniciantransmissionsByDate.map(techniciantransmission => (
      <div>   
          <Grid>
            <Grid.Column width='16' >
            <Accordion>
          <Accordion.Title 
                      onClick={handleTitleClick} 
                      index={techniciantransmission.id}
                      active={activeIndex === techniciantransmission.id}
                    >
                      <Grid style={{fontSize: '15px'}}>
                    <Grid.Column width='5'>
                    
                    <Icon name='dropdown' />
                    {(techniciantransmission.estimatedCompletionDate === null) ? '' :
            <span><strong>{convertDate(techniciantransmission.estimatedCompletionDate.substr(0,10))}</strong>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{getDayOfWeek(techniciantransmission.estimatedCompletionDate)}</p></span>}
                    
                    </Grid.Column>
                    
                    <Grid.Column width='3' verticalAlign='middle'>
                    <Link to={`/employeeportal/sitevodafone?siteid=${techniciantransmission.projectSite.siteId}`} style={{ color: "blue" }}>
                      {techniciantransmission.projectSite.siteId}</Link>
                    </Grid.Column>
                    <Grid.Column width='8' verticalAlign='middle'>
                    {techniciantransmission.projectSite.siteName}
                    </Grid.Column>
                    </Grid>
                    </Accordion.Title>
                    <Accordion.Content active={activeIndex === techniciantransmission.id}>
                      <Table definition unstackable>
    <Table.Body>
      <Table.Row>
        <Table.Cell collapsing>Site Id</Table.Cell>
        <Table.Cell>
        <Link to={`/employeeportal/sitevodafone?siteid=${techniciantransmission.projectSite.siteId}`}
         style={{ color: "blue" }}>
                      {techniciantransmission.projectSite.siteId}</Link>
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>Site Name</Table.Cell>
        <Table.Cell> {techniciantransmission!.projectSite.siteName} </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>Type</Table.Cell>
        <Table.Cell> {techniciantransmission!.projectSite.structureType} </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>Company</Table.Cell>
        <Table.Cell> {techniciantransmission!.orderNumber} </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>Ring Id</Table.Cell>
        <Table.Cell> {techniciantransmission!.projectSite.ringId} </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>Upstream Site Id</Table.Cell>
        <Table.Cell> 
        <Link to={`/employeeportal/sitevodafone?siteid=${techniciantransmission.projectSite.upstreamSiteId}`} style={{ color: "blue" }}>
                      {techniciantransmission.projectSite.upstreamSiteId}</Link>
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>Upstream Site Name</Table.Cell>
        <Table.Cell> {techniciantransmission!.projectSite.upstreamSiteName} </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>Upstream WP</Table.Cell>
        <Table.Cell> {techniciantransmission!.projectSite.upstreamWP} </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>Sequence</Table.Cell>
        <Table.Cell> {techniciantransmission!.projectSite.sequence} </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>State</Table.Cell>
        <Table.Cell> {techniciantransmission!.projectSite.state} </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>Address</Table.Cell>
        {/* <Table.Cell> {techniciantransmission!.projectSite.address} </Table.Cell> */}
        <Table.Cell><a href={`https://maps.google.com/?q=${techniciantransmission!.projectSite.address}`} target="_Blank">
          {techniciantransmission!.projectSite.address}</a></Table.Cell> 
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>Date</Table.Cell>
        <Table.Cell> {techniciantransmission!.estimatedCompletionDate} </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>Work Shift</Table.Cell>
        <Table.Cell> {techniciantransmission!.projectSite.time} </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing>Remark</Table.Cell>
        <Table.Cell> {techniciantransmission!.remark} </Table.Cell>
      </Table.Row>
    </Table.Body>
    </Table>
        </Accordion.Content>
        </Accordion>
        </Grid.Column>
                  </Grid>
                  <Divider/>
                  </div>
    ))}
    </div>
  );
};

export default observer(TechnicianTransmission);
